import AboutUsPage from "@components/Pages/AboutUsPage/AboutUsPage";
import React from "react";

export default function UmOkkur() {
    return <AboutUsPage />;
}

export async function getStaticProps({ locale }) {
    return {
        props: {
            messages: (await import(`../locales/${locale}.json`)).default,
        },
    };
}
